export const DASHBOARD = {};
DASHBOARD.UPDATE_DASHBOARD_COUNTER = "UPDATE_DASHBOARD_COUNTER";
DASHBOARD.SET_CURRENT_DASHBOARD_TAB = "SET_CURRENT_DASHBOARD_TAB";
